import { Checkbox, CloseButton, Flex, Group, NumberInput, Select } from "@mantine/core";
import { useForm } from "@mantine/form";
import React from "react";

export interface AddOrderItemProps {
  licenseData?: { value: string; label: string }[];
  removeItem: () => void;
  form: ReturnType<typeof useForm<any>>;
  index: number;
}

const AddOrderItem: React.FC<AddOrderItemProps> = (props) => {
  const { licenseData, removeItem, form, index } = props;
  return (
    <Flex justify={"space-between"} align="center">
      <Group align="flex-end" gap={"md"}>
        <Select
          label="License Type"
          placeholder="License type"
          data={licenseData}
          allowDeselect={false}
          {...form.getInputProps(`orderItems.${index}.licenseType`)}
        />
        <NumberInput
          placeholder="Quantity"
          min={1}
          {...form.getInputProps(`orderItems.${index}.quantity`)}
        />
        <Checkbox
          label={`Add ${form.values.orderItems[index].quantity} Hardware to the order`}
          {...form.getInputProps(`orderItems.${index}.isHardware`)}
        />
      </Group>
      <CloseButton c="red" size={"lg"} onClick={removeItem} />
    </Flex>
  );
};

export default AddOrderItem;
